import { Exercise } from './../models/exercise';
import { Component, OnInit, Input, OnChanges, AfterViewChecked } from '@angular/core';
import { VideoService } from '../services/video.service';
import { Router } from '@angular/router'
import { UserService } from '../services/user.service';
import { PaypalService } from '../services/paypal.service';
import { Location } from '@angular/common';


declare let paypal: any;

@Component({
	selector: 'exercise-content',
	templateUrl: './exercise-content.component.html',
	styleUrls: ['./exercise-content.component.css']
})
export class ExerciseContentComponent implements OnInit,AfterViewChecked {

	private videoList;
	private user;
	@Input() exerciseId;
	private exercise: Exercise;
	private bought: boolean = false;
	private canBuyBundle: boolean = true;
	private boughtVideosCounter: number;
	private favorite: boolean = false;
	private disableFavorite: boolean = false;
	private id: number;
	private loggedIn: boolean = true;
	public priceList;

	addScript: boolean = true;

	constructor(
		private videoService: VideoService,
		private router: Router,
		private userService: UserService,
		private paypalService: PaypalService,
		private location: Location
	) { }


	ngOnInit() {
		this.id = this.exerciseId
		this.getExercise(this.id).then(()=>{
			this.userService.getRecords('bought_bundles',this.user.session_token).then((boughtBundlesList: Array<any>)=>{
				this.priceList.forEach((bundle, index) => {
					if(!boughtBundlesList.some( boughtBundle => boughtBundle.purchaseId === bundle.purchase_id)){
						if(this.bought && this.exercise.bundle.some( exerciseBundle => exerciseBundle.purchase_id === bundle.purchase_id)){
							this.priceList[index].bought = true;
						}else{
							let paypalBundleConfig = this.createPaypalConfig(bundle.price,bundle.purchase_id);
							paypal.Button.render(paypalBundleConfig,'#paypal-bundle-button-' + bundle.bundle_id);
						}
					}else{
						this.priceList[index].bought = true;
					}
				});
			})
		})
		this.user = JSON.parse(localStorage.getItem('user'));
		this.priceList = JSON.parse(localStorage.getItem("priceList"))
		setTimeout(()=>{

		}, 0)

	}

	ngAfterViewChecked():void{

		if(!this.addScript && this.exercise){
			/*
			//this.addPaypalScript().then(()=>{
				let paypalConfig = this.paypalService.createPaypalConfig(this.exercise.price.toString(),this.exercise.purchaseId);
				let paypalBundleConfig = this.paypalService.createPaypalConfig('29.99','starter_bundle_1');
				paypal.Button.render(paypalConfig,'#paypal-single-button');
				paypal.Button.render(paypalBundleConfig,'#paypal-bundle-button');
			//})
			*/
		}
	}

	addPaypalScript(){
		this.addScript = true;
		return new Promise((resolve,reject)=>{
			let scripttagElement = document.createElement('script');
			scripttagElement.src = "https://www.paypalobjects.com/api/checkout.js";
			scripttagElement.onload = resolve;
			document.body.appendChild(scripttagElement);
		})
	}

    
    createPaypalConfig(price: string, purchaseId: string){
		let that = this;
		let historyId = 0;
		let errorMessage = "Unknown Error";
		let paypalConfig = {

            env: 'production', // sandbox | production

            style: {
                label: 'pay',
                size:  'medium',    // small | medium | large | responsive
                shape: 'rect',     // pill | rect
                color: 'gold'      // gold | blue | silver | black
            },

            // PayPal Client IDs - replace with your own
            // Create a PayPal app: https://developer.paypal.com/developer/applications/create
            client: {
				sandbox:    'ASIqfv8x7wyupu7VlsBme2hlmtggYZ89xDQrBYETFpJwKKEm6oKL0DPehqjJ_7CwojLWdR5HhMi8mMHL',
				production: 'AcYl5yTPHT0rzB5lb4GW6zy2jW4CgtQ0bNo4w91-aVfb6sFy3jKA9m-ILq1-H1F9_v2JmqqjIIZtVVjx'
            },
    
            // Show the buyer a 'Pay Now' button in the checkout flow
            commit: true,
    
            // payment() is called when the button is clicked
            payment: function(data, actions) {
				let user = JSON.parse(localStorage.getItem("user"));
				if(purchaseId !== 'starter_bundle'){
					that.userService.setPurchaseHistoryEntry(user.session_token,user.id,purchaseId,'web',false).then((res: number)=>{
						historyId = res;
					})
				}else{
					that.userService.setPurchaseHistoryEntry(user.session_token,user.id,purchaseId,'web',true)
					.then((res: number)=>{
						historyId = res;
					})
				}
                // Make a call to the REST api to create the payment
                return actions.payment.create({
                    payment: {
                        transactions: [
                            {
                                amount: { total: price, currency: 'EUR' }
                            }
                        ]
                    }
                });
            },
    
            // onAuthorize() is called when the buyer approves the payment
            onAuthorize: function(data, actions) {
    
                // Make a call to the REST api to execute the payment
                return actions.payment.execute().then(function() {
					let user = JSON.parse(localStorage.getItem("user"));
					if(purchaseId === that.exercise.purchaseId){
						that.userService.setBoughtVideo('bought_videos',user.session_token,user.id,purchaseId).then(()=>{
							that.userService.updatePurchaseHistoryEntry(user.session_token,historyId,"completed","Videokauf erfolgreich");						
							if(that.boughtVideosCounter === 1){
								that.canBuyBundle = false;
							}
						},(error) => {
							errorMessage = JSON.stringify(error);
							that.userService.updatePurchaseHistoryEntry(user.session_token,historyId,"error",errorMessage);
						});
					}else{
						that.userService.setBoughtVideo('bought_bundles',user.session_token,user.id,purchaseId)
						.then(()=>{
							that.userService.updatePurchaseHistoryEntry(user.session_token,historyId,"completed","Paketkauf erfolgreich");
							that.canBuyBundle = false;
						},(error) => {
							errorMessage = JSON.stringify(error);
							that.userService.updatePurchaseHistoryEntry(user.session_token,historyId,"error",errorMessage);
						});
					}
                    that.bought = true;
                    console.log('Bought item with id: ', purchaseId)
                    //console.log('Payment Complete! for',exercise.purchaseId);
                });
            }
		}	
		return paypalConfig;
	}

	ngOnChanges() {
		this.id = this.exerciseId
		// remove old button
		document.getElementById('paypal-single-button').innerHTML = 'lädt...';

		console.log("Video Component Initialized")
		const exercises = JSON.parse(localStorage.getItem("exercises"));
		
		this.getExercise(this.id).then(()=>{
			if(!this.bought){
				document.getElementById('paypal-single-button').innerHTML = '';
				// Config Paypal button for current exercise
				let paypalConfig = this.createPaypalConfig(this.exercise.price.toString(),this.exercise.purchaseId);
				paypal.Button.render(paypalConfig,'#paypal-single-button');
			}
		});
	}

	// Function to get exercise everytime the Exercise ID changes
	getExercise(exerciseId): Promise<any> {
		let user = JSON.parse(localStorage.getItem("user"))

		return new Promise((resolve,reject)=>{
			const exercises = JSON.parse(localStorage.getItem("exercises"));
			let exercise = exercises.find(exercise =>  exercise.id === exerciseId); 
			this.exercise = {
				bundle: exercise.bundles,
				id: exercise.id,
				title: exercise.title,
				description: exercise.description,
				purchaseId: exercise.purchaseId,
				url: exercise.url,
				posterUrl: exercise.url.replace('.mp4','.jpg'),
				price: exercise.price,
				keyfacts: exercise.keyfacts,
				free: exercise.free
			}
			if(user){
				this.videoService.checkIfVideoBought(this.exercise)
				.then((isBought: any)=>{
					if(user){
						this.boughtVideosCounter = isBought.boughtVideosCounter;
						if(isBought.bundleBought || isBought.boughtVideosCounter > 1){
							this.canBuyBundle = false;
						}else{
							this.canBuyBundle = true;
						}
						if(isBought.videoBought || isBought.bundleBought){
							this.bought = true;
						}else{
							this.bought = false;
						}				
						this.videoService.checkIfVideoFavorite(this.exercise).then((isFavorite: any)=>{
							if(isFavorite){
								this.favorite = isFavorite.id;
							}else{
								this.favorite = false;
							}
							resolve();
						})
					}
				},(err)=>{
					console.log("Fehler beim Laden der Videos: ", err);
					this.router.navigate(['login']);
				})
			}else{
				this.canBuyBundle = false;
				this.loggedIn = false;
			}

		})

	}

	manageFavorite(){
		let user = JSON.parse(localStorage.getItem('user'));
		if(user){
		if(!this.disableFavorite){
			this.disableFavorite = true;
			if(!this.favorite){
				this.userService.setRecord('favorites',user.session_token,user.id,this.exercise.id)
				.then((res: any)=>{
					console.log(res)
					this.favorite = res.id;
					this.disableFavorite = false;
				})
			}else{
				this.userService.deleteRecord('favorites',user.session_token,user.id,this.exercise.id, this.favorite)
				.then(()=>{
					this.favorite = false;
					this.disableFavorite = false;
				})
			}
		}
		}else{
			this.router.navigate(['login']);
		}
	}

	goBack() {
		this.location.back();
	}   

}



// WEBPACK FOOTER //
// ./src/app/exercise-content/exercise-content.component.ts